import { ApiConsume } from '../../../_API/ApiConsume';

// ApiConsume no lanza: devuelve { status, data, msg_error }. React-query necesita
// un error para reintentar o mostrar el estado, así que lo convertimos acá.
// Sin redirección por 401: esto se consulta en segundo plano y el interceptor
// de axios ya se ocupa de refrescar el token.
const pedir = async (section, method = 'GET', { body = {}, id = null, params = {} } = {}) => {
  const res = await ApiConsume(section, method, body, id, '', false, params, false);
  if (!res || res.status < 200 || res.status >= 300) {
    const error = new Error(res?.msg_error || 'No se pudieron cargar las novedades.');
    error.status = res?.status;
    throw error;
  }
  return res.data;
};

export const obtenerResumen = () => pedir('NOVEDADES_WAM__RESUMEN');

export const obtenerPagina = async (page = 1) => {
  const data = await pedir('NOVEDADES_WAM__LIST', 'GET', { params: { page } });
  return { ...data, page };
};

export const marcarLeida = (id) => pedir('NOVEDADES_WAM__LEIDA', 'POST', { id });

export const leerTodas = () => pedir('NOVEDADES_WAM__LEER_TODAS', 'POST');

export const marcarModalCerrado = (id) => pedir('NOVEDADES_WAM__MODAL_CERRADO', 'POST', { id });

export const registrarEvento = (id, tipo) => pedir('NOVEDADES_WAM__EVENTO', 'POST', { id, body: { tipo } });
